const META_PIXEL_ID = '948540081392381'

type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  push: (...args: unknown[]) => void
  loaded: boolean
  version: string
}

type TrackingWindow = Window & {
  fbq?: MetaPixelFunction
  _fbq?: MetaPixelFunction
}

export function loadMetaPixel(): void {
  const metaWindow = window as TrackingWindow
  if (metaWindow.fbq) return

  const pixel = function (...args: unknown[]) {
    if (pixel.callMethod) pixel.callMethod(...args)
    else pixel.queue.push(args)
  } as MetaPixelFunction
  pixel.queue = []
  pixel.push = (...args: unknown[]) => pixel.queue.push(args)
  pixel.loaded = true
  pixel.version = '2.0'
  metaWindow.fbq = pixel
  metaWindow._fbq = pixel

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  script.dataset.metaPixel = 'true'
  document.head.appendChild(script)

  pixel('init', META_PIXEL_ID)
  pixel('track', 'PageView')
}
